module.exports = __webpack_public_path__ + "static/media/subscribe-card-background.cee00c31.png";